import React from "react";

export default function DonutChart({ segments, size = 140, strokeWidth = 18 }) {
  const total = segments.reduce((a, s) => a + s.value, 0) || 1;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  // Precompute each segment's cumulative starting offset (as a rotation) without
  // mutating state during the render pass below.
  const cumulative = [];
  segments.reduce((acc, seg) => {
    cumulative.push(acc);
    return acc + seg.value;
  }, 0);

  return (
    <svg width={size} height={size} className="transform -rotate-90 shrink-0">
      <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="currentColor" strokeWidth={strokeWidth} className="text-[#f1f3f4] dark:text-[#3c4043]" />
      {segments.map((seg, i) => {
        const fraction = seg.value / total;
        const dash = fraction * circumference;
        const gap = circumference - dash;
        const rotation = (cumulative[i] / total) * 360;
        if (seg.value === 0) return null;
        return (
          <circle
            key={i}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={seg.color}
            strokeWidth={strokeWidth}
            strokeDasharray={`${dash} ${gap}`}
            style={{ transform: `rotate(${rotation}deg)`, transformOrigin: "50% 50%", transition: "stroke-dasharray 0.6s ease" }}
          />
        );
      })}
    </svg>
  );
}
